<template>
  <v-card>
    <v-list-item
        dark
        class="primary"
    >
      <v-list-item-avatar>
        <v-icon>
          mdi-account
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Applicants</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon @click.prevent="minimize = !minimize">
          <v-icon v-if="!minimize">mdi-chevron-up</v-icon>
          <v-icon v-else>mdi-chevron-down</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-card-text v-if="!minimize">
      <v-list class="applicants-list">
        <v-sheet
            v-for="applicant in applicants"
            :key="applicant.id"
            class="d-flex flex-row pa-3 applicants-list-item"
        >
          <div class="d-flex flex-column flex-grow-1">
            <div class="applicants-list-item__name">
              {{ applicant.firstname }} {{ applicant.middlename }} {{ applicant.lastname }}
              <v-chip v-if="applicant.is_main" small dark color="indigo lighten-2">Main</v-chip>
            </div>
            <div class="applicants-list-item__description">
              Age: {{ applicant.birthdate | formatYearsFrom }}, DOB: {{ applicant.birthdate }}, {{
                applicant.gender
              }}
            </div>
            <div v-if="isAdmin" class="pt-2">
              <v-btn v-if="applicant.firstname" text x-small @click.prevent="copyToClipboard(applicant.firstname)">
                <v-icon left>mdi-content-copy</v-icon>
                {{ applicant.firstname }}
              </v-btn>
              <v-btn v-if="applicant.middlename" text x-small @click.prevent="copyToClipboard(applicant.firstname)">
                <v-icon left>mdi-content-copy</v-icon>
                {{ applicant.middlename }}
              </v-btn>
              <v-btn v-if="applicant.lastname" text x-small @click.prevent="copyToClipboard(applicant.firstname)">
                <v-icon left>mdi-content-copy</v-icon>
                {{ applicant.lastname }}
              </v-btn>
            </div>
          </div>
          <div v-if="applicant.birthcertificate" class="d-flex flex-column">
            <v-btn
                :to="applicant.birthcertificate"
                color="indigo"
                icon
                large
                target="_blank"
                title="Download Birth Certificate"
            >
              <v-icon>mdi-certificate</v-icon>
            </v-btn>
          </div>
          <div v-if="applicant.passport" class="d-flex flex-column">
            <v-btn
                :to="applicant.passport"
                target="_blank"
                icon
                color="indigo"
                large
                title="Download passport"
            >
              <v-icon>mdi-passport</v-icon>
            </v-btn>
          </div>
          <div v-if="isAdmin" class="d-flex flex-column">
            <applicant-edit-dialog :id="applicant.id" @success="fetchData"></applicant-edit-dialog>
          </div>
        </v-sheet>
      </v-list>
    </v-card-text>

  </v-card>
</template>
<script>
import moment from 'moment'
import ApplicantEditDialog from './EditDialog'
import {errorNotification} from "@/components/utils";
import {mapGetters} from "vuex";
// import {createApplicant} from './const'

export default {
  components: {
    ApplicantEditDialog
  },
  name: 'ApplicationApplicants',
  props: {
    id: Number
  },
  data() {
    return {
      minimize: false,
      dialog: false,
      applicants: []
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isAdmin'
    ]),
  },
  filters: {
    formatYearsFrom(date) {
      return moment().diff(date, 'years', false);
    }
  },
  methods: {
    fetchData() {
      this.$axios.get('/applications/' + this.id + '/applicants/', {})
          .then((response) => {
            this.applicants = response.data
          })
          .catch((error) => {
            errorNotification(error)
          })
    },
    copyToClipboard(content) {
      navigator.clipboard.writeText(content).then(
          () => {
            this.$store.dispatch('snackbar/success', 'Content copied to clipboard')
          },
          () => {
            this.$store.dispatch('snackbar/error', 'Content wasn\'t copied to clipboard')
          },
      )
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.applicants-list {
  &-item {
    &:hover {
      background: lighten(grey, 46);
    }

    &__name {
      font-weight: bold;
    }
  }
}
</style>